var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcInfoOutlineRed35X35 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 36 35"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#EB1700",
  d: "M16.5 20a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1zM17.25 27a1 1 0 0 1-1-1v-1.5a1 1 0 0 1 1-1h1.5a1 1 0 0 1 1 1V26a1 1 0 0 1-1 1z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#EB1700",
  fillRule: "evenodd",
  d: "M.25 17.5c0 9.665 7.835 17.5 17.5 17.5s17.5-7.835 17.5-17.5S27.415 0 17.75 0 .25 7.835.25 17.5m32 0c0 8.008-6.492 14.5-14.5 14.5s-14.5-6.492-14.5-14.5S9.742 3 17.75 3s14.5 6.492 14.5 14.5",
  clipRule: "evenodd"
})));
export default SvgIcInfoOutlineRed35X35;